var map = {
	"./anm-card.png": 1218,
	"./arrow.png": 1219,
	"./arrow.webp": 1220,
	"./asset-1.svg": 1221,
	"./bg-exclusive.webp": 1222,
	"./boost.svg": 1223,
	"./brand-logo-cny.png": 1224,
	"./brand-logo-raya.webp": 1225,
	"./brand-logo.png": 113,
	"./brand-logo.webp": 1226,
	"./btn-black-m.webp": 1227,
	"./btn-blue-m-v2.png": 1228,
	"./btn-blue-m.png": 1229,
	"./btn-blue-m.webp": 1230,
	"./btn-white-m-v2.png": 1231,
	"./btn-white-m.png": 1232,
	"./check-btn.webp": 1233,
	"./default-bg.webp": 1234,
	"./deposit.webp": 1235,
	"./drop-more-btn.webp": 1236,
	"./duitnow.svg": 1237,
	"./eeziepay.svg": 1238,
	"./fcl.svg": 1239,
	"./fcl.webp": 1240,
	"./fpx-logo.svg": 1241,
	"./game-blue.png": 1242,
	"./game-img.png": 1243,
	"./game-white.png": 1244,
	"./global-language.svg": 1245,
	"./grabpay.svg": 1246,
	"./ifm-logo.svg": 1247,
	"./ifm-logo.webp": 1248,
	"./modal-bg.jpg": 1249,
	"./number-bg.webp": 1250,
	"./pagcor.svg": 1251,
	"./pagcor.webp": 1252,
	"./pool-bg.webp": 1253,
	"./promo-given.webp": 1254,
	"./side-bar-bg.png": 1255,
	"./spotlight-base.svg": 1256,
	"./spotlight.svg": 1257,
	"./tether.svg": 1258,
	"./title-asset.svg": 1259,
	"./tng.svg": 1260,
	"./winner.webp": 1261,
	"./withdrawal.webp": 1262
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;